import {jsx} from 'panel';

import {UserIconEl} from 'common/widgets/user-icon';
import {SvgIconEl} from 'common/components/svg-icon';
import {TextHighlightEl} from 'common/components/text-highlight';
import {SelectEl} from 'common/components/select';
import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';

const getUserIconEl = (id: number, name: string) => (
  <UserIconEl
    attrs={{
      id,
      name,
      'disable-tooltip': true,
      size: `medium`,
    }}
  />
);

export const GetHelpLink = (marginStyle, handleHelpClick) => (
  <div
    sel='.help'
    attrs={{
      style: marginStyle,
    }}
  >
    <a
      attrs={{
        href: `https://help.mixpanel.com/hc/en-us/articles/360044299311`,
        target: `_blank`,
      }}
      on={{
        click: handleHelpClick,
      }}
    >
      Learn About Sharing
    </a>
  </div>
);

export const GetOwnerListItem = (helpers) => {
  const isNewStyle = helpers.isNewStyle();
  const owner = helpers.getEntityOwner();
  const userIcon = isNewStyle ? getUserIconEl(owner.id, owner.name) : null;

  return (
    <li attrs={{elref: `owner`}}>
      {userIcon}
      <div sel='.display'>
        <>
          <div sel='.name' class={{'name--new-style': helpers.isNewStyle()}}>
            {owner.formattedName}
          </div>
          <div sel='.subtitle'>{owner.email}</div>
        </>
      </div>
      <div sel='.controls'>
        <div sel='.creator-label' class={{'creator-label--new-style': helpers.isNewStyle()}}>
          Creator
        </div>
      </div>
    </li>
  );
};

export const GetUpsellBanner = () => (
  <div sel='.banner'>
    <div sel='.upsell-icon-wrapper'>
      <SvgIconEl
        attrs={{
          icon: `lightning-bolt`,
          color: `green`,
        }}
      />
    </div>
    <p>
      <strong>Upgrade your plan </strong>
      to gain access to advanced sharing and additional privacy controls. On your current plan
      <strong> Starter (Free) </strong>
      everything you create will be viewable and editable by others in this project
    </p>
  </div>
);

export const ShareSection = (title, items, helpers) => {
  const isNewStyle = helpers.isNewStyle();

  return items || (title === `People` && helpers.entityHasOwner()) ? (
    <div sel='.share-section' attrs={{elref: `shareSection${title}`}}>
      <header>{title}</header>
      <ul sel='.share-list'>
        {title === `People` && helpers.entityHasOwner() ? GetOwnerListItem(helpers) : null}
        {items &&
          items.map((share) => {
            const shareGrant = helpers.existingShares.getShareItem(share);
            return (
              <li attrs={{elref: `share_${shareGrant.id}`}}>
                {isNewStyle ? getUserIconEl(shareGrant.id, helpers.getShareGrantDisplayName(shareGrant)) : null}
                <div sel='.display'>
                  <div sel='.name-wrapper'>
                    <div sel='.name' class={{'name--new-style': helpers.isNewStyle()}}>
                      {helpers.getShareGrantDisplayName(shareGrant)}
                    </div>
                    {isNewStyle ? (
                      <TextHighlightEl
                        attrs={{
                          theme: `success`,
                          text: helpers.getShareGrantStatusText(shareGrant.grantStatus),
                        }}
                      />
                    ) : null}
                  </div>
                  {title === `People` ? (
                    <div sel='.subtitle'>{shareGrant.email}</div>
                  ) : (
                    <div sel='.subtitle'>{`${helpers.existingShares.getTeamMembersCount(shareGrant)} People`}</div>
                  )}
                </div>
                <div sel='.controls'>
                  <SelectEl
                    sel='.share-level'
                    attrs={{
                      'disable-search': true,
                      'menu-width': 120,
                      theme: `tertiary`,
                      'always-show-caret': true,
                      sections: JSON.stringify(helpers.getSelectOptions()),
                      'selected-option': share.canEdit ? `Editor` : `Viewer`,
                      elref: `selectShareLevel_${shareGrant.id}`,
                      'use-fixed-dropmenu-pos': true,
                    }}
                    on={{
                      change: (ev) => helpers.existingShares.handleShareLevelSelectChange(ev, shareGrant),
                    }}
                    class={{'share-level--new-style': isNewStyle}}
                  />
                  {!isNewStyle ? (
                    <ButtonEl
                      sel='.delete'
                      attrs={{
                        theme: ButtonTheme.Tertiary,
                        icon: `trashcan`,
                        elref: `deleteShare_${shareGrant.id}`,
                      }}
                      on={{
                        click: () => helpers.existingShares.handleDeleteButtonClick(shareGrant),
                      }}
                    />
                  ) : null}
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  ) : null;
};
